import {useState} from "react";

export default function useConfirmDialog(onConfirm) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [itemName, setItemName] = useState("");

  const openDialog = (id, name = "") => {
    setItemToDelete(id);
    setItemName(name);
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    setConfirmOpen(false);
    if (itemToDelete && onConfirm) {
      await onConfirm(itemToDelete);
    }
    setItemToDelete(null);
    setItemName("");
  };

  const handleCancel = () => {
    setConfirmOpen(false);
    setItemToDelete(null);
    setItemName("");
  };

  return {
    confirmOpen,
    itemName,
    openDialog,
    handleConfirm,
    handleCancel
  };
}
